import { from, map, Observable, switchMap } from 'rxjs';

export function blobUrlToFile(blobUrl: string, filename: string): Observable<File> {
  return from(fetch(blobUrl)).pipe(
    switchMap((response) => from(response.blob())),
    map((blob) => new File([blob], filename, { type: blob.type }))
  );
}
